import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthApi } from '../api-definition'
import { config } from '../config'

export const AuthenticatedApiClient = generateApiClient(config.apiName, AuthApi.routes)
export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
